<script lang="ts" setup>
import { ref, onMounted, computed, onBeforeMount } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { getRootTranslationCategories } from '../helper';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

const route = useRoute();
const router = useRouter();
const rootCategories = ref([]);
const targetCategories = ref([]);
const rootLanguageId = ref(import.meta.env.VITE_ADMIN_DEFAULT_TRANSLATION_ID)
const targetLanguageId = ref(Array.isArray(route.params.translation) ? route.params.translation[0] : route.params.translation)

onMounted( async () => {
    rootCategories.value = await getRootTranslationCategories(rootLanguageId.value);
    targetCategories.value = await getRootTranslationCategories(targetLanguageId.value);
});

</script>

<template>
    <div class="mt-5">
        <DataTable :value="rootCategories" tableStyle="min-width: 50rem">

           
            <!-- Root Language Column with Tooltip -->
            <Column field="name" header="Root Language">
                <template #body="{ data }">
                    <div>{{ data.name }}</div>
                </template>
            </Column>
            
            <!-- Target Language Column with Tooltip -->
            <Column header="Target Language">
                <template #body="{ data, index }">
                    <div v-if="!targetCategories[index]?.name">
                        <Tag severity="secondary">Not Translated</Tag>
                    </div>
                    <div v-else>
                    <span v-tooltip.top="targetCategories[index].name">
                        {{ targetCategories[index].name }}
                    </span>
                    </div>
                
                </template>
            </Column>
            
            <!-- Edit Button Column -->
            <Column header="Actions">
                <template #body="{ index }">
                    <Button @click="router.push('edit/' + index)" label="Edit" class="p-button-tuev">
                        <template #icon>
                            <FontAwesomeIcon icon="edit" />
                        </template>
                    </Button>
                </template>
            </Column>
        </DataTable>
    </div>
</template>
